<template>

  <div :id="id">
    <slot name="title">
      <div
        :class="{'border-bottom': !noTitleBorder}"
        class="pb-1 mb-4 d-flex justify-content-between align-items-sm-end"
      >
        <AppTitle :title="title" :type="type" :no-border="noTitleBorder"/>
        <slot name="secondButton">
          <b-button
            v-if="secondButton"
            class="ml-auto"
            :variant="secondButtonVariant"
            @click="$emit('onClickSecondButton')"
          >
            <i v-if="secondButtonIcon" :class="[{'mr-2': secondButtonText}, secondButtonIcon]"></i>
            <AppSvgIcon v-if="secondButtonIconSvg" :icon="secondButtonIconSvg"></AppSvgIcon>
            {{$t(secondButtonText) | capitalize}}
          </b-button>
        </slot>
        <slot name="firstButton">
          <b-button
            v-if="button"
            :class="{'ml-3' : secondButton , 'ml-auto': !secondButton}"
            :variant="buttonVariant"
            @click="$emit('onClick')"
            :size="buttonSize"
            v-b-tooltip
            :title="buttonIconSvgTooltip"
          >
            <i v-if="buttonIcon" :class="[{'mr-2': buttonText}, buttonIcon]"></i>
            <AppSvgIcon v-if="buttonIconSvg" :icon="buttonIconSvg"></AppSvgIcon>
            {{$t(buttonText) | capitalize}}
          </b-button>
        </slot>
        <slot name="language" v-if="language">
          <lang-flag :iso="languageCode" :squared="false" class="lx ml-auto"/>
          <AppTitle :title="languageName" type="sub-section-2" :no-border="false" style="margin-top: 8px;"/>

        </slot>
        <div class="float-right">

          <b-form-checkbox v-if="checkBox" class="d-inline" switch v-model="checked" size="lg" @change="$emit('onChangeCheckBox', checked)">

          </b-form-checkbox>

        </div>
      </div>
    </slot>
    <b-overlay :show="isSectionLoading" rounded="lg" :style="{minHeight: setMinHeight ? '10rem': 'auto'}">
      <template #overlay>
        <AppSpinner class="text-secondary mx-auto" size="8"/>
      </template>
      <slot></slot>
    </b-overlay>
  </div>

</template>

<script>
  import AppTitle from "./AppTitle";
  import AppSpinner from "../utils/AppSpinner";

  export default {
    name: "AppSection",
    components: {AppSpinner, AppTitle},
    props: {
      isSectionLoading: {
        type: Boolean,
        default: false
      },
      id: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'section',
        validator: function (value) {
          return ['page', 'section', 'sub-section-1', 'sub-section-2'].indexOf(value) !== -1
        }
      },
      noTitleBorder: {
        type: Boolean,
        default: false
      },
      button: {
        type: Boolean,
        default: false
      },
      buttonText: {
        type: String,
        default: ''
      },

      buttonVariant: {
        type: String,
        default: 'secondary'
      },
      buttonIcon: {
        type: String,
        default: ''
      },

      buttonIconSvg: {
        type: String,
        default: ''
      },
      language: {
        type: Boolean,
        default: false
      },
      languageCode: {
        type: String,
        default: ''
      },
      languageName: {
        type: String,
        default: ''
      },
      setMinHeight: {
        type: Boolean,
        default: true
      },
      checkBox: {
        type: Boolean,
        default: false
      },
      checkBoxModel: {
        default: '',
      },

      secondButton: {
        type: Boolean,
        default: false
      },
      secondButtonText: {
        type: String,
        default: ''
      },

      secondButtonVariant: {
        type: String,
        default: 'secondary'
      },
      secondButtonIcon: {
        type: String,
        default: ''
      },

      secondButtonIconSvg: {
        type: String,
        default: ''
      },

      buttonSize: {
        type: String,
        default: 'md'
      },

      buttonIconSvgTooltip: {
        type: String,
        default: ''
      }

    },
    data() {
      return {
        checked: this.checkBoxModel
      }
    },
  }
</script>

<style>

</style>
